document.addEventListener("DOMContentLoaded", (event) => {
  const sizeGuideBtn = document.querySelector('.size-guide-popup');
  const sizeGuideInches = document.querySelector('#size-chart-inches');
  const sizeGuideCM = document.querySelector('#size-chart-centimeters');
  
  sizeGuideBtn.addEventListener('click', () => {
    const radioInches  = document.querySelectorAll('.radio-group-in')[1];
    const radioCM = document.querySelectorAll('.radio-group-cm')[1];
    radioCM?.querySelector('#input-centimeters')?.setAttribute('id', 'input-centimeters-2')
    radioCM?.querySelector('.radio-label')?.setAttribute('for', 'input-centimeters-2')
    radioInches.querySelector('#input-inches').setAttribute('id', 'input-inches-2')
     radioInches.querySelector('#input-inches-2').click();
    radioInches.querySelector('.radio-label').setAttribute('for', 'input-inches-2')
  })
})
